export enum Mode {
    Filter = "filter",
    Matno = "matno",
    MatnoReduced = "matno-reduced",
}

export enum ButtonType {
    Shop = "shop",
    Rental = "rental",
}

export default interface Config {
    mode: Mode;
    buttonType: ButtonType;
    initialChunkSize: number;
    chunkSize: number;
    initialSorting: string;
    sortOptions: Array<string>;
};
